import getIgnoreTokenHeader from 'lowcode/utils/service/getIgnoreTokenHeader';
import { baseUrl } from '../util';
import request from '@/utils/request';

export const getProductDownload = (params: { spuIds: string; classify?: 'VIDEO_COURSE' | 'ONLINE' }, locale?: string) => {
    // 解决sourceId丢失导致获取全部数据
    const fakeId = '1562721273280900000'; // 1562721273280901121
    params.spuIds = params.spuIds || fakeId;
    return request(`${baseUrl(locale)}/cms/downloadInfoForWeb/downloadInfo/v2`, {
        method: 'get',
        params,
        headers: {
            ...getIgnoreTokenHeader(),
        },
    });
};
